import { Injectable } from '@angular/core';
import { FieldConfig } from '../models/field.interface';

@Injectable()
export class StyleService {

    constructor(
    ) { }

    applyStyle(field: FieldConfig) {
        if (field.style.background_color || field.style.border_color || field.style.border_thickness || field.style.corner_radius) {
            let styleObject = {
                'background-color': 'rgb' + field.style.background_color + '',
                'borderColor': 'rgb' + field.style.border_color + '',
                'borderWidth': Math.floor(field.style.border_thickness),
                'borderRadius': Math.floor(field.style.corner_radius) + 'px'
            };
            return styleObject
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/rFF/services/style.service.ts